<template>
  <div class="news-page">
    <!-- 页面标题条 -->
    <div class="page-hero">
      <div class="container">
        <h1>新闻动态</h1>
        <p>了解公司最新动态与行业资讯</p>
      </div>
    </div>

    <div class="container content">
      <!-- 搜索栏：按标题关键字搜索，回车即可搜索 -->
      <div class="search-bar">
        <el-input
          v-model="query.keyword"
          placeholder="输入标题关键字搜索"
          clearable
          style="max-width: 360px"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-input>
      </div>

      <!-- 新闻列表 -->
      <div v-loading="loading" class="news-list">
        <router-link v-for="n in list" :key="n.id" :to="`/news/${n.id}`" class="news-item">
          <div class="news-cover">
            <img v-if="n.cover" :src="n.cover" :alt="n.title">
            <div v-else class="img-placeholder">暂无图片</div>
          </div>
          <div class="news-body">
            <h4 class="news-title">{{ n.title }}</h4>
            <p class="news-summary">{{ n.summary || '暂无摘要' }}</p>
            <div class="news-meta">
              <span><i class="el-icon-date"></i> {{ dateText(n.created_at) }}</span>
              <span><i class="el-icon-view"></i> {{ n.views }}</span>
            </div>
          </div>
        </router-link>
      </div>

      <el-empty v-if="!loading && list.length === 0" description="没有找到相关新闻" />

      <!-- 分页：总数大于一页时才显示 -->
      <el-pagination
        v-if="total > query.size"
        class="pagination"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="query.size"
        :current-page="query.page"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { getNewsList } from '../api'

export default {
  name: 'NewsList',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      // 查询条件：页码、每页条数、标题关键字
      query: { page: 1, size: 10, keyword: '' }
    }
  },
  created() {
    this.fetchList()
  },
  // 从详情页返回时保留滚动位置体验更好，这里不做特殊处理，保持简单
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await getNewsList(this.query)
        this.list = res.data.list
        this.total = res.data.total
      } finally {
        this.loading = false
      }
    },
    // 搜索时回到第 1 页
    handleSearch() {
      this.query.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchList()
    },
    dateText(datetime) {
      return (datetime || '').slice(0, 10)
    }
  }
}
</script>

<style scoped>
.content { padding: 32px 0 60px; }

.search-bar { margin-bottom: 24px; }

.news-list { display: flex; flex-direction: column; gap: 16px; }
.news-item {
  display: flex;
  gap: 18px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  transition: all 0.25s;
}
.news-item:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.news-cover {
  flex: 0 0 220px;
  height: 132px;
  border-radius: 6px;
  overflow: hidden;
  background: #eef0f3;
}
.news-cover img { width: 100%; height: 100%; object-fit: cover; }
.news-body { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.news-title {
  margin: 2px 0 10px;
  font-size: 18px;
  color: #1f2d3d;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.news-summary {
  flex: 1;
  margin: 0 0 12px;
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-meta { color: #909399; font-size: 13px; display: flex; gap: 20px; }
.news-meta i { margin-right: 4px; }

.pagination { margin-top: 28px; text-align: center; }
</style>
